module.exports = __webpack_public_path__ + "eaba914a8d8de44fdf73f417ced1f60d.png";